import { render } from "./PropPageSearch.vue?vue&type=template&id=288cdf51"
import script from "./PropPageSearch.vue?vue&type=script&lang=js"
export * from "./PropPageSearch.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/vacatia/releases/20150122151115/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__